export const convertNumberToPx = (value: number) => {
    return `${value}px`;
};
